import React from 'react';
import ConfirmModal from './ConfirmModal';

const LogoutModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirmar Saída', 
  message = 'Tem certeza de que deseja sair do sistema?',
  confirmText = 'Sair',
  cancelText = 'Cancelar',
  icon: Icon
}) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
      confirmVariant="danger"
      icon={Icon}
    />
  );
};

export default LogoutModal;